import React from 'react';
import Button from '../../Subcomponents/Button';
import CustomInput from '../../Subcomponents/CustomInput';
import DropDown from '../../Subcomponents/DropDown';
import cssClasses from './UpdatePrice.module.css';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Divider } from '@mui/material';

export default function UpdatePrice({ childLaunch, setChildLaunch, floors }) {
  return (
    <div className={cssClasses.mainContainer}>
      <div className={cssClasses.content}>
        <div className={cssClasses.plc}>
          <Divider />
          {/* <div className={cssClasses.row} style={{ marginTop: '2rem' }}>
            <Box className={cssClasses.label}>PLC </Box>
            <div style={{ flex: 1 }}>
              {childLaunch?.plc?.map((m, index) => (
                <div key={`${m}_${index}`} className={cssClasses.views}>
                  <div style={{ flex: 1 }}>
                    <CustomInput
                      style={{
                        background: '#FFFFFF !important',
                        pointerEvents: 'none',
                      }}
                      value={m.name}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <CustomInput
                      inputType={'number'}
                      value={m.value}
                      disabled={m.type === ''}
                      handleChange={(e) => {
                        setChildLaunch((pre) => {
                          pre.plc[index].value = e;
                          return { ...pre };
                        });
                      }}
                      placeholder={'enter price'}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <DropDown
                      placeHolder={'Select'}
                      selectedValue={m.type}
                      onChangeSelect={(e) => {
                        setChildLaunch((pre) => {
                          pre.plc[index].type = e;
                          return { ...pre };
                        });
                      }}
                      list={['Percentage', 'Value', 'per sq ft']}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div> */}
          <div className={cssClasses.row} style={{ gap: '1.8rem' }}>
            <Box className={cssClasses.label1}>Floor Rise </Box>
            <div style={{ flex: 1 }}>
              {childLaunch?.floorRise?.map((m, index) => (
                <div key={`${m}_${index}`} className={cssClasses.views}>
                  <div style={{ width: '33%' }}>
                    <div style={{ flex: 1, marginBottom: '2.4rem' }}>
                      {/* {m.from} */}
                      <DropDown
                        disable={true}
                        placeHolder={'From'}
                        selectedValue={m.from}
                        onChangeSelect={(e) => {
                          setChildLaunch((pre) => {
                            pre.floorRise[index].from = e;
                            return { ...pre };
                          });
                        }}
                        list={floors}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <CustomInput
                        inputType={'number'}
                        value={m.value}
                        disabled={m.type === ''}
                        handleChange={(e) => {
                          setChildLaunch((pre) => {
                            pre.floorRise[index].value = e;
                            return { ...pre };
                          });
                        }}
                        placeholder={'enter price'}
                      />
                    </div>
                  </div>
                  <div style={{ width: '33%' }}>
                    <div style={{ flex: 1, marginBottom: '2.4rem' }}>
                      {/* {m.to} */}
                      <DropDown
                        placeHolder={'To'}
                        selectedValue={m.to}
                        onChangeSelect={(e) => {
                          setChildLaunch((pre) => {
                            pre.floorRise[index].to = e;
                            return { ...pre };
                          });
                        }}
                        // list={floors.filter(
                        //   (e, index) =>
                        //     index >= floors.findIndex((e) => e === m.from)
                        // )}
                        list={floors.filter(f => f > m.from)}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <DropDown
                        placeHolder={'Select'}
                        selectedValue={m.type}
                        onChangeSelect={(e) => {
                          setChildLaunch((pre) => {
                            pre.floorRise[index].type = e;
                            return { ...pre };
                          });
                        }}
                        list={['Percentage', 'Value', 'per sq ft']}
                      />
                    </div>
                  </div>
                  {index > 0 && (
                    <Box mt={1}>
                      <DeleteIcon
                        style={{
                          width: '3rem',
                          height: '3rem',
                          color: 'rgb(21, 112, 239)',
                        }}
                        onClick={() => {
                          setChildLaunch((pre) => {
                            pre.floorRise.splice(index, 1);
                            return { ...pre };
                          });
                        }}
                      />
                    </Box>
                  )}
                </div>
              ))}
              <div style={{ width: '25rem' }}>
                {childLaunch?.floorRise?.length > 0 &&
                  !(
                    childLaunch?.floorRise[0]?.from === floors[0] &&
                    childLaunch?.floorRise[childLaunch?.floorRise?.length - 1]
                      ?.to === floors[floors.length - 1]
                  ) && (
                    <Box>
                      <Button
                        disable={
                          !childLaunch?.floorRise[
                            childLaunch.floorRise.length - 1
                          ]?.to
                        }
                        btnIcon={
                          <AddCircleOutlineIcon
                            color='#1570EF'
                            style={{ width: '2rem', height: '2rem' }}
                          />
                        }
                        btnName={'Add Floor Rise'}
                        iconPosition={'left'}
                        style={{
                          color: '#1570EF',
                          backgroundColor: '#FFFFFF',
                          border: 'none',
                          boxShadow: 'unset',
                          display: 'flex',
                        }}
                        padding={'0'}
                        clicked={() => {
                          setChildLaunch((pre) => {
                            pre.floorRise.push({
                              // from: floors[floors.findIndex((e) => e === childLaunch?.floorRise[ childLaunch.floorRise.length - 1]?.from) + 1],
                              from: +pre?.floorRise[pre.floorRise.length - 1].to + 1,
                              to: null,
                              value: null,
                              type: '',
                            });
                            return { ...pre };
                          });
                        }}
                      />
                    </Box>
                  )}
              </div>
            </div>
          </div>
          <Divider />
          <div
            className={cssClasses.row}
            style={{ gap: '1.8rem', marginTop: '2rem' }}
          >
            <Box className={cssClasses.label1}>Parking </Box>
            <div style={{ flex: 1 }}>
              {childLaunch?.parking?.map((m, index) => (
                <div key={`${m}_${index}`} className={cssClasses.views}>
                  <div style={{ flex: 1 }}>
                    <CustomInput
                      style={{ background: '#FFFFFF !important' }}
                      placeholder={'enter parking'}
                      value={m.name}
                      handleChange={(e) => {
                        setChildLaunch((pre) => {
                          pre.parking[index].name = e;
                          return { ...pre };
                        });
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <CustomInput
                      inputType={'number'}
                      value={m.value}
                      disabled={m.type === ''}
                      handleChange={(e) => {
                        setChildLaunch((pre) => {
                          pre.parking[index].value = e;
                          return { ...pre };
                        });
                      }}
                      placeholder={'enter price'}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <DropDown
                      placeHolder={'Select'}
                      selectedValue={m.type}
                      onChangeSelect={(e) => {
                        setChildLaunch((pre) => {
                          pre.parking[index].type = e;
                          return { ...pre };
                        });
                      }}
                      list={['Percentage', 'Value', 'per sq ft']}
                    />
                  </div>
                  {index > 0 && (
                    <Box mt={1}>
                      <DeleteIcon
                        style={{
                          width: '3rem',
                          height: '3rem',
                          color: 'rgb(21, 112, 239)',
                        }}
                        onClick={() => {
                          setChildLaunch((pre) => {
                            pre.parking.splice(index, 1);
                            return { ...pre };
                          });
                        }}
                      />
                    </Box>
                  )}
                </div>
              ))}
              <div style={{ width: '25rem' }}>
                <Button
                  btnIcon={
                    <AddCircleOutlineIcon
                      color='#1570EF'
                      style={{ width: '2rem', height: '2rem' }}
                    />
                  }
                  btnName={'Add Parking'}
                  iconPosition={'left'}
                  style={{
                    color: '#1570EF',
                    backgroundColor: '#FFFFFF',
                    border: 'none',
                    boxShadow: 'unset',
                    display: 'flex',
                  }}
                  padding={'0'}
                  clicked={() => {
                    setChildLaunch((pre) => {
                      pre.parking.push({ value: null, type: '' });
                      return { ...pre };
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
